import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../Frames/Layout";
import { useEffect, useState } from "react";
import DPC from '../../../../services/API/DPC';
import { Alert, TextField, Stack, Button, IconButton, Box } from "@mui/material";
import Loader from '../../../Tools/Loader';
import { LoadingButton } from "@mui/lab";
import { Add, Delete, Save } from "@mui/icons-material";

export default function Plan(){

    const navigate = useNavigate();

    const {id} = useParams();
    
    const [action, setAction] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {

        DPC.getAction(id)
            .then(r => setAction(r.data))
            .catch(e => console.log(e))

    }, [id])
    
 
    const handleSubmit = e => {
        e.preventDefault()

        DPC.putAction(action)
            .then(r => handleSuccess(r))
            .catch(e => handleError(e))

        return setLoading(true);
    }

    const handleSuccess = r => {
        console.log(r.data);
        return navigate(-1);
    }

    const handleError = e => {
        console.log(e.response?.data);
        setLoading(false);
        return setError(true);
    }

    const handleChange = (index, prop, value) => {
        let copy = JSON.parse(JSON.stringify(action));
        copy.plan[index][prop] = value;
        setAction(copy);
    }

    const handleAdd = () => {
        let copy = JSON.parse(JSON.stringify(action));
        copy.plan.push({title: '', duration: ''});
        setAction(copy);
    }

    const handleDelete = index => {
        let copy = JSON.parse(JSON.stringify(action));
        copy.plan.splice(index, 1);
        setAction(copy);
    }

    return <Layout tab='actions' menu='dpc' title='Déroulé pédagogique' back>

        {action && <form onSubmit={handleSubmit}>

            <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={1} sx={{mb: 3}}>

                <p>{action.title}</p>

                <Box>

                    <LoadingButton 
                        loading={loading} 
                        type='submit'
                        startIcon={<Save />}
                        variant='contained'
                    >
                        Enregistrer
                    </LoadingButton>

                </Box>

            </Stack>

        
            <Stack direction='column' alignItems='center' spacing={2}>

                {error && <Alert severity='error'>Une erreur s'est produite.</Alert>}

                {action.plan.map((r,i) => 
                    <Stack direction='row' spacing={2} key={i}>
                        
                        <TextField
                            label="Titre de la partie"
                            value={r.title || ''}
                            onChange={e => handleChange(i, 'title', e.target.value)}
                            required
                            size='small'
                        />

                        <TextField
                            label="Durée (min)"
                            type="number"
                            value={r.duration || ''}
                            onChange={e => handleChange(i, 'duration', parseInt(e.target.value))}
                            inputProps={{min: 1, step: 1,}}
                            required
                            size='small'
                        />

                        <IconButton onClick={() => handleDelete(i)}>
                            <Delete />
                        </IconButton>

                    </Stack>
                )}

                <Button 
                    type='button'
                    onClick={handleAdd}
                    startIcon={<Add />}
                >
                    Ajouter une partie
                </Button>

            </Stack>
        
        </form>}

        
        {!action && <Loader />}

    </Layout>
}
